import { render } from "./AddPost.vue?vue&type=template&id=4db15e21"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__